import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/matco-v2-back/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/matco-v2-back/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/components/common/NotFound.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/components/common/ToggleTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/components/contactUs/ContactUsForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/components/soluciones/MoreInformationButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/components/ui/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/components/ui/MovilMenu/MovilMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/bitnami/apache/htdocs/matco-v2-back/src/components/ui/YellowSideMenu/YellowSideMenu.tsx");
